import styled from "styled-components";

import * as Sticker from "ds/Sticker";

export const Wrapper = styled(Sticker.Root)`
  margin: 16px 0;
  padding: 24px;
  border-radius: 2px;
  display: block;
`;

export const Header = styled.header`
  margin: 0 0 16px 0;
`;

export const Remaining = styled.div`
  display: flex;
  font-weight: bold;
  font-size: 15px;
  line-height: 24px;
  color: var(--header-ebony-color, var(--ebony));
`;

export const Credit = styled.span`
  margin-left: auto;
  font-weight: 600;
`;

export const Expiration = styled.p`
  margin: 0;
  font-weight: 600;
  font-size: 13px;
  line-height: 18px;
  color: var(--section-slate-color, var(--slate)) !important;
`;

export const Content = styled.div`
  word-break: normal;
  p {
    margin: 0;
    font-size: 15px;
    line-height: 24px;
    color: var(--section-ebony-color, var(--ebony));
    a {
      text-decoration: none;
      &:hover {
        text-decoration: underline;
      }
    }
  }
`;
